module.exports = __webpack_public_path__ + "static/media/tti_why_talentx@2x.273df974.png";